export default __webpack_public_path__ + "static/media/ROX_4763.ba716c9a.jpg";